import React from 'react'
import Banner from '../components/banner/Banner'
import Work from '../components/work/Work'
import BestServices from '../components/services/BestServices'
import Benifits from '../components/benefits/Benifits'
import AppTesimonial from '../components/testimonials/AppTesimonial'
import Pricing from '../components/pricing/Pricing'
import Faq from '../components/faq/Faq'

function App() {

  return (
    <>
      <Banner />
      <Work />
      <BestServices />
      <Benifits />
      <AppTesimonial />
      <Pricing />
      <Faq />

    </>
  )
}

export default App